import { round2, safeNumber } from './math'

/** Operational cost from purchase base. */
export class OperationalCostCalculator {
  calculate(purchasePrice: number, operationalPercent: number): number {
    return round2(safeNumber(purchasePrice) * (safeNumber(operationalPercent) / 100))
  }

  fromAbsolute(value: number): number {
    return round2(Math.max(0, safeNumber(value)))
  }
}
